import get from 'lodash/get';

export const ERROR_CODE = 'Error Code';
export const NOT_DIAGNOSED = 'Not Diagnosed';
export const NOT_DIAGNOSED_ID = 'repair-ticket-not-diagnosed-id';

export function getRepairTicketCategory(vehicleBrand, vehicleType, repairTicketCategories) {
  const foundCodes = get(repairTicketCategories, [vehicleBrand, vehicleType]);
  return foundCodes || [];
}
